import { createSlice } from "@reduxjs/toolkit";
import { api } from "service/api";
import { RegionApi } from "service/apiVariables";
import { Toast } from "service/toast";
import { addQuery } from "utils";
import { setLoader } from "./loader";

export const regionSlice = createSlice({
  name: "region",
  initialState: {
    regions: null,
    inactiveRegions: null,
    isLoading: false,
    regionData: {},
    activeRegion: null,
    inactiveRegion: null,
  },
  reducers: {
    saveRegionList: (state, action) => {
      state.regions = action.payload;
      state.isLoading = false;
    },

    saveInactiveRegionList: (state, action) => {
      state.inactiveRegions = action.payload;
      state.isLoading = false;
    },

    saveRegionData: (state, action) => {
      state.regionData = action.payload;
      state.isLoading = false;
    },

    setSelectedActiveRegion: (state, action) => {
      state.activeRegion = action.payload;
    },

    setSelectedInactiveRegion: (state, action) => {
      state.inactiveRegion = action.payload;
    },
  },
});
// get active region list
export const getRegionListAct = (query) => (dispatch) => {
  RegionApi.getRegionListApi.addQuery = query;
  addQuery(query || {}, RegionApi.getRegionListApi);

  dispatch(setLoader(true));

  return new Promise((resolve, reject) => {
    api({ ...RegionApi.getRegionListApi })
      .then(({ data }) => {
        dispatch(saveRegionList(data));
        dispatch(setLoader(false));
        resolve(data);
      })
      .catch((err) => {
        if (err?.status === 400) {
          dispatch(saveRegionList(err?.data));
          dispatch(setLoader(false));
          resolve(err?.data);
        } else {
          dispatch(setLoader(false));
          reject(Toast({ type: "error", message: err?.message }));
        }
      });
  });
};

// get inactive region list
export const getInactiveRegionListAct = (query) => (dispatch) => {
  RegionApi.getRegionListApi.addQuery = query;
  addQuery(query || {}, RegionApi.getRegionListApi);

  dispatch(setLoader(true));

  return new Promise((resolve, reject) => {
    api({ ...RegionApi.getRegionListApi })
      .then(({ data }) => {
        dispatch(saveInactiveRegionList(data));
        dispatch(setLoader(false));
        resolve(data);
      })
      .catch((err) => {
        if (err?.status === 400) {
          dispatch(saveInactiveRegionList(err?.data));
          dispatch(setLoader(false));
          resolve(err?.data);
        } else {
          dispatch(setLoader(false));
          reject(Toast({ type: "error", message: err?.message }));
        }
      });
  });
};

// get individual region detail
export const getRegionByIdAct = (id) => (dispatch) => {
  dispatch(setLoader(true));

  const baseConfig = RegionApi.getRegionByIdApi;
  const apiConfig = {
    method: baseConfig.method,
    baseURL: baseConfig.baseURL,
    api: baseConfig.api(id),
  };

  return new Promise((resolve, reject) => {
    api(apiConfig)
      .then((data) => {
        dispatch(saveRegionData(data?.data));
        dispatch(setLoader(false));
        resolve(data?.data);
      })
      .catch(({ message }) => {
        dispatch(setLoader(false));
        reject(Toast({ type: "error", message }));
      });
  });
};

// add region
export const createRegionAct = (body) => () => {
  return new Promise((resolve, reject) => {
    api({ ...RegionApi.createRegionApi, body })
      .then((data) => {
        Toast({
          type: "success",
          message: data?.message || "Region added successfully",
        });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

// update region
export const updateRegionAct = (id, body) => () => {
  const baseConfig = RegionApi.updateRegionApi;
  const apiConfig = {
    method: baseConfig.method,
    baseURL: baseConfig.baseURL,
    api: baseConfig.api(id),
    body,
  };

  return new Promise((resolve, reject) => {
    api(apiConfig)
      .then((data) => {
        Toast({
          type: "success",
          message: data?.message || "Region updated successfully",
        });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

// delete / inactive region
export const activeInactiveRegionAct = (id, status) => () => {
  const baseConfig = RegionApi.changeRegionStatusApi;

  const apiConfig = {
    method: baseConfig.method,
    baseURL: baseConfig.baseURL,
    api: baseConfig.api(id, status),
  };

  return new Promise((resolve, reject) => {
    api(apiConfig)
      .then((data) => {
        Toast({
          type: "success",
          message:
            data?.message ||
            `Region ${status === "active" ? "activated" : "inactivated"} successfully`,
        });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};
export const deleteRegionAct = (id, status) => () => {
  const baseConfig = RegionApi.deleteRegionApi;

  const apiConfig = {
    method: baseConfig.method,
    baseURL: baseConfig.baseURL,
    api: baseConfig.api(id, status),
  };

  return new Promise((resolve, reject) => {
    api(apiConfig)
      .then((data) => {
        Toast({
          type: "success",
          message: data?.message || "Region deleted successfully",
        });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

// activate inactive region
export const activateRegionAct = (id, status) => () => {
  const baseConfig = RegionApi.changeRegionStatusApi;

  const apiConfig = {
    method: baseConfig.method,
    baseURL: baseConfig.baseURL,
    api: baseConfig.api(id, status),
  };

  return new Promise((resolve, reject) => {
    api(apiConfig)
      .then((data) => {
        Toast({
          type: "success",
          message: data?.message || "Region activated successfully",
        });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

export const {
  saveRegionList,
  saveInactiveRegionList,
  saveRegionData,
  setSelectedActiveRegion,
  setSelectedInactiveRegion,
} = regionSlice.actions;

export default regionSlice.reducer;
